import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ContactModel } from '@boxx/contacts-core';
import {
  LeadModel,
  MessageSource,
  MESSAGE_SOURCES_METADATA,
} from '@boxx/messages-core';
import { COUNTRIES_DATA } from 'src/assets/countriesData';
import { ConversationItemOpenComponent } from '../conversation-item-open/conversation-item-open.component';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'boxx-lead-item-open',
  templateUrl: './lead-item-open.component.html',
  styleUrls: ['./lead-item-open.component.scss'],
})
export class LeadItemOpenComponent
  extends ConversationItemOpenComponent
  implements OnInit
{
  @Input() override set message(payload: LeadModel) {
    this.myMessage = payload;
  }

  override get message(): LeadModel {
    return this.myMessage as LeadModel;
  }

  @Input() isDetailView = false;

  @Input() set contact(payload: ContactModel) {
    this.myContact = payload;

    this.flagKey = Object.keys(COUNTRIES_DATA).filter(
      (key) => COUNTRIES_DATA[key].alpha3Code === this.contact?.countryCode
    )[0];
  }

  get contact() {
    return this.myContact;
  }

  @Output() whenSendEmail = new EventEmitter<string>();
  @Output() whenAddContact = new EventEmitter();

  messageSources = MESSAGE_SOURCES_METADATA;

  // eslint-disable-next-line @typescript-eslint/naming-convention
  override MESSAGE_SOURCE = MessageSource;

  flagKey: string;

  private myContact: ContactModel;

  constructor() {
    super();
  }

  ngOnInit(): void {}

  sendEmail() {
    this.whenSendEmail.emit(this.message.email);
  }

  addContact() {
    this.whenAddContact.emit();
  }
}
